define('FileUploadPDP.ei1.Main', [
    'FileUploadPDP.ei1.Main.View',
    'FileUploadPDP.ei1.Cart.View',
    'FileUploadPDP.ei1.ServiceFee'
], function (
    FileUploadPDPMainView,
    FileUploadPDPCartView,
    FileUploadPDPServiceFee
) {
    'use strict';

    // Internal ID(s) of the Copy item(s) this upload widget should show
    // on. TODO: replace with the actual internal ID of the ONHO Copy
    // item (Lists > Accounting > Items, or the URL when editing the item).
    var ENABLED_ITEM_IDS = [21098];

    return {
        mountToApp: function mountToApp(container) {
            this._mountCart(container);
            FileUploadPDPServiceFee.init(container);

            var layout = container.getComponent('PDP');

            if (!layout) {
                return;
            }

            layout.addChildView('FileUploadPDP.View', function () {
                var itemInfo = layout.getItemInfo();
                var itemId = itemInfo && itemInfo.item && itemInfo.item.internalid;

                if (ENABLED_ITEM_IDS.indexOf(parseInt(itemId, 10)) === -1) {
                    return false;
                }

                return new FileUploadPDPMainView({ container: container });
            });

            // Quantity/option changes cause SCA to re-render the PDP (and the
            // Add to Cart button), so the view needs to refresh totals/price
            // AND immediately re-apply the upload gate - otherwise the freshly
            // re-rendered button appears enabled for a moment before our poll
            // catches it.
            function refreshUploadView() {
                var view = layout.getChildView && layout.getChildView('FileUploadPDP.View');
                if (view) {
                    // SCA re-renders on option change and resets BOTH the line
                    // quantity (back to 1) and its own price display (back to
                    // the matrix unit price). So when a file is already
                    // uploaded, re-assert our pages*copies quantity and
                    // recompute the displayed price - otherwise selecting an
                    // option silently reverts the price to the per-page rate.
                    if (view.uploadedFile && view.applyQuantityForPages) {
                        view.applyQuantityForPages();
                    } else if (view.recalculatePrice) {
                        view.recalculatePrice();
                    }

                    // SCA updates the selected option's matrix price AFTER
                    // this event (asynchronously). Rather than guess a delay,
                    // wait for it to settle, then recompute our price - with
                    // a brief "Updating price..." overlay during the wait.
                    if (view.uploadedFile && view.recalculatePriceWhenSettled) {
                        view.recalculatePriceWhenSettled();
                    }
                    setTimeout(function () {
                        if (view._refreshAddToCartState) {
                            view._refreshAddToCartState();
                        }
                    }, 0);

                    if (view._refreshAddToCartState) {
                        view._refreshAddToCartState();
                    }
                }
            }

            layout.on('afterOptionSelection', refreshUploadView);
        },

        // Cart page: lock quantity + add page/pages label on Copy lines.
        // The cart view is pure DOM (detects Copy lines by the "Upload Page
        // Count" text in each .cart-lines-row), so we don't depend on the
        // Cart component being reachable via getComponent - we just watch the
        // page for cart line rows and (re-)apply whenever they change. SCA
        // rebuilds the rows on quantity/line edits, so a MutationObserver is
        // the version-proof way to keep our changes applied.
        _mountCart: function _mountCart(container) {
            var cartView = new FileUploadPDPCartView();
            var scheduled = false;
            var observer = null;

            // Apply our cart changes WITHOUT letting them re-trigger the
            // observer (which caused an infinite re-apply loop / blinking).
            // We disconnect while mutating, then reconnect.
            function applyToCart() {
                scheduled = false;
                if (observer) { observer.disconnect(); }
                try {
                    cartView.apply();
                } finally {
                    if (observer) {
                        observer.observe(document.body, { childList: true, subtree: true });
                    }
                }
            }
            function scheduleApply() {
                if (scheduled) { return; }
                scheduled = true;
                setTimeout(applyToCart, 200);
            }

            function hasCart() {
                return document.querySelector('.cart-lines-row, input[name="quantity"]') !== null;
            }

            [200, 600, 1200, 2000].forEach(function (d) {
                setTimeout(function () { if (hasCart()) { applyToCart(); } }, d);
            });

            if (window.MutationObserver) {
                observer = new MutationObserver(function () {
                    if (hasCart()) { scheduleApply(); }
                });
                observer.observe(document.body, { childList: true, subtree: true });
            }
        }
    };
});
